<template>
  <v-col col="12">
    <v-row dense>
      <v-col col="4">
        <day-select
          v-model="form.day"
          :year="form.year"
          :month="form.month"
          :rules="getRulesByName('day')"
          :error-messages="errors.day"
          :label="`${$t('ITEM.DATE')} *`"
          @input="updateValue('day', $event)"
        />
      </v-col>
      <v-col col="4">
        <month-select
          v-model="form.month"
          :label="`${$t('ITEM.MONTH')} *`"
          :rules="getRulesByName('month')"
          :error-messages="errors.month"
          @input="updateValue('month', $event)"
        />
      </v-col>
      <v-col cols="4">
        <year-select
          v-model="form.year"
          :label="$t('ITEM.YEAR')"
          :error-messages="errors.year"
          @input="updateValue('year', $event)"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import DaySelect from '@/modules/holidays/components/forms/Date/DaySelect';
import MonthSelect from '@/modules/holidays/components/forms/Date/MonthSelect';
import YearSelect from '@/modules/holidays/components/forms/Date/YearSelect';
import { notEmpty } from '@/modules/_global/variables/rules';
import formEditable from '@/modules/_global/mixins/form-editable';

export default {
  name: 'DatePickerSelect',
  components: { YearSelect, MonthSelect, DaySelect },

  mixins: [formEditable],

  data() {
    return {
      rules: {
        day: [notEmpty],
        month: [notEmpty]
      }
    };
  }
};
</script>

<style scoped></style>
